<template>
    <v-autocomplete
            :label="(label)? label : 'Búsqueda de cliente'"
            :items="items"
            :value="value"
            item-text="A1_NOME"
            item-value="A1_COD"
            clearable
            hide-no-data
            :search-input.sync="search"
            @input="actualizaValor($event)"
            :loading="loading"
            return-object
            :error-messages="errores.collect('item')"
            v-validate="validate"
            data-vv-name="item"
            @blur="$emit('blur')"
            @change="change($event)"
            :filter="customFilter"
    >
    </v-autocomplete>
</template>
<script>
    import mixinClientes from '../mixins/micro/clientes'

    export default {
        inject: ['$validator'],
        name: 'micro-cliente-select',
        props: ['label', 'value', 'tipo', 'preset', 'validate', 'empresa'],
        mixins: [mixinClientes],
        data() {
            return {
                search: '',
                loading: false,
                listado: []
            }
        },
        computed: {
            items() {
                return (this.preset) ? ((this.preset && Object.keys(this.preset).length !== 0) ? [this.preset] : []) : this.listado;
            }
        },
        watch: {
            search(val) {
                if (!val) {
                    return false;
                }
                let valor = (this.value && typeof this.value === 'object' && this.value.A1_NOME) ? this.value.A1_NOME : '';
                val && val !== valor && this.query(val)
            }
        },
        methods: {
            query(val) {
                this.loading = true;
                this.microClienteBuscar({
                    empresa: this.empresa,
                    q: val
                }, r => {
                    this.listado = r;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                })
            },
            customFilter(item, queryText, itemText) {
                let A1_NOME = (item.A1_NOME) ? item.A1_NOME.toLowerCase().includes(queryText.toLowerCase()) : false;
                let A1_COD = (item.A1_COD) ? item.A1_COD.toLowerCase().includes(queryText.toLowerCase()) : false;
                return (A1_NOME || A1_COD);
            },
            actualizaValor(valor) {
                this.$emit('update:id', (valor) ? valor.A1_COD : '');
                this.$emit('input', valor);

            },
            change(e) {
                this.$emit('change', e);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/MicroClienteSelect.vue